<template>
	<!-- 营业执照信息上传组件 -->
	<el-row>
		<el-col :span="24">
			<!-- form -->
			<el-form ref="license" :model="license" :rules="rules" label-width="90px" size="small">
				<!-- title -->
				<div class="flex-prompt">
					营业执照
					<span class="msg" :style="{ color: staleDay.type === 'Expired' ? '#FF3939' : '#E47D2F' }">{{ staleDay.state + staleDay.day }}</span>
				</div>
				<el-form-item prop="type" class="text-left" v-show="typeNames !== 1 || (typeNames === 2 && businessNatureNames === 1)">
					<div><el-radio v-model="license.type" label="1" :disabled="operationState > 2" @change="typeChange">有</el-radio></div>
					<div><el-radio v-model="license.type" label="2" :disabled="operationState > 2" @change="typeChange">没有</el-radio></div>
				</el-form-item>
				<div v-show="typeNames === 1 || (typeNames === 2 && businessNatureNames === 1 && license.type === '1')">
					<el-form-item prop="ImgList" class="text-left">
						<!-- 新增，编辑权限 -->
						<div v-if="operationState !== 3">
							<div>
								<!-- 图片上传 -->
								<el-upload
									:class="{ hide: count === 4, licenseBox: count < 1 }"
									ref="licenseUpload"
									action=""
									:http-request="handleUploadRequest"
									accept=".jpg,.png,.jpeg"
									:auto-upload="true"
									:limit="4"
									list-type="picture-card"
									:on-preview="handlePictureCardPreview"
									:on-remove="handleRemove"
									:before-upload="beforeAvatarUpload"
									:file-list="licenseFileList"
									:on-change="licenseChange"
								>
									<i class="el-icon-plus"></i>
								</el-upload>
							</div>
						</div>
						<!-- 查看权限 -->
						<div v-else>
							<ul class="flex-palace">
								<li>
									<el-image
										@click="handlePictureCardPreview('https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg')"
										style="width: 160px; height: 94px"
										src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
										fit="cover"
									></el-image>
								</li>
							</ul>
						</div>
						<!-- 大图预览弹窗 -->
						<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
					</el-form-item>
					<el-form-item label="证件号:" prop="No" class="text-left">
						<el-input style="width: 280px;" v-model="license.No" clearable maxlength="40" :disabled="operationState > 2" placeholder="请输入证件号"></el-input>
					</el-form-item>
					<el-form-item label="有效期:" prop="Time" class="text-left last">
						<el-col :span="7">
							<el-date-picker
								v-model="license.Time"
								:clearable="false"
								:disabled="operationState > 2"
								value-format="yyyy-MM-dd"
								type="date"
								style="width: 100%;padding-right: 20px;"
								placeholder="请选择有效期"
								@change="pickerChange"
							/>
						</el-col>
						<el-col :span="4"><el-checkbox v-model="checked" :disabled="operationState > 2" @change="checkedChange">长期</el-checkbox></el-col>
					</el-form-item>
				</div>
			</el-form>
		</el-col>
	</el-row>
</template>

<script>
import {oss,bucketConfig} from '@/utils/oss';
export default {
	props: {
		// 编辑数据
		initLicenseData: {
			type: Object,
			default: () => {}
		},
		// 客户类型
		typeName: {
			type: Number,
			default: () => 1
		},
		// 有效期对象
		licenseStaleDay: {
			type: Object,
			default: () => ''
		},
		// 经营性质
		businessNatureName: {
			type: Number,
			default: () => 1
		}
	},
	data() {
		return {
			// 提交表单数据
			license: {
				type: '1', //是否有证 1是，2否
				Xtype: 1, //资质种类标记
				Name: '营业执照', //证件名称
				ImgList: [], //提交图片对象
				Time: '', // 有效期
				No: '' //证件号
			},
			// 有效期
			staleDay: {
				state: '',
				day: '',
				type: ''
			},
			// 营业执照上传按钮显示切换 图片长度
			count: 0,
			// 有效期，长期勾选参数
			checked: false,
			// 大图预览url
			dialogImageUrl: '',
			// 大图预览弹窗
			dialogVisible: false,
			// 表单基础数据验证规则
			rules: {
				No: [{ required: true, message: '请输入证件号', trigger: 'blur' }],
				Time: [{ required: true, message: '请选择日期', trigger: 'change' }],
				type: [{ required: true, message: '请选择类型', trigger: 'change' }]
			},
			// 页面操作状态 1新增，2编辑，3查看
			operationState: 1,
			// 上传文件集合
			licenseFileList: [],
			// 经营性质切换临时缓存值
			businessNatureNames: '',
			// 客户类型切换临时缓存值
			typeNames: ''
		};
	},
	watch: {
		// 监听参数变化，区分新增和编辑，查看状态
		initLicenseData: {
			handler(newData, oldData) {
				if (newData.initLicenseData === undefined) {
					return;
				}
				// 设置客户类型，经营性质初始值
				this.updateInfo(newData.data);
				// 渲染数据
				this.updateData(newData.initLicenseData);
			},
			deep: true,
			immediate: false
		},
		// 监听参数变化（客户类型）
		typeName: {
			handler(newData, oldData) {
				this.typeNames = newData;
				this.businessNatureNames === 2 ? (this.license.type = '2') : (this.license.type = '1');
			},
			deep: true,
			immediate: true
		},
		// 监听参数变化（经营性质）
		businessNatureName: {
			handler(newData, oldData) {
				this.businessNatureNames = newData;
				this.businessNatureNames === 1 ? (this.license.type = '1') : (this.license.type = '2');
			},
			deep: true,
			immediate: false
		},
    // 监听内部参数变化（经营性质）
		businessNatureNames: {
			handler(newData, oldData) {
				this.businessNatureNames = newData;
				this.businessNatureNames === 1 ? (this.license.type = '1') : (this.license.type = '2');
			},
			deep: true,
			immediate: false
		},
		licenseStaleDay: {
			handler(newData, oldData) {
				if (newData.licenseStaleDay === undefined) {
					return;
				}
				let staleDay = JSON.parse(newData.licenseStaleDay);
				if (staleDay && staleDay.Type && staleDay.Type !== null) {
					if (staleDay.Type === 'Warning') {
						// 将要过期
						this.staleDay = {
							state: '(将要过期,剩',
							day: staleDay.StaleDay + '天)',
							type: staleDay.Type
						};
					}
					if (staleDay.Type === 'Expired') {
						// 过期
						this.staleDay = {
							state: '(已过期',
							day: staleDay.StaleDay + '天)',
							type: staleDay.Type
						};
					}
				}
			},
			deep: false,
			immediate: false
		}
	},
	mounted() {},
	methods: {
		/*
		 * 设置客户类型，经营性质初始值
		 */
		updateInfo(data) {
			let obj = data;
			this.typeNames = obj.CustomerType;
			obj.BusinessNature === null ? (this.businessNatureNames = 2) : (this.businessNatureNames = obj.BusinessNature);
		},
		/*
		 * 渲染数据
		 */
		updateData(data) {
			let obj = JSON.parse(data);
			// 设置页面操作状态
			this.operationState = obj.operationState;

			if (obj.StateCenter.HasBusinessLincense !== null) {
				if (obj.StateCenter.HasBusinessLincense) {
					// 存在，回显参数
					// 遍历匹配对应模块数据
					obj.ZzInfos.forEach(item => {
						if (item.Xtype === 1) {
							// 展示图片默认赋值
							if (item.ImgList.length > 0) {
								item.ImgList.forEach(i => {
									// 展示默认值
									this.licenseFileList.push({
										// url: i.substring(0, i.lastIndexOf('.')) + '_s.' + i.substring(i.lastIndexOf('.') + 1, i.length) //图片地址
										url: i //图片地址
									});
									// 自定义计数器
									this.count++;
								});
							}
							this.license = {
								type: this.typeNames === 1 || (this.typeNames === 2 && this.businessNatureNames === 1) ? '1' : '2', //是否有证书
								Xtype: item.Xtype, //资质种类标记
								Name: item.Name, //证件名称
								Time: item.Time, // 有效期
								No: item.No, //证件号
								ImgList: item.ImgList //图片集合
							};
						}
					});
				} else {
					this.license.type = '2';
				}
			} else {
				this.license.type = '2';
			}
		},
		/*
		 * 是否有营业执照切换监听
		 */
		typeChange(e) {
			this.license.type = e;
			console.log(this.license)
			e === '2' ? (this.businessNatureNames = 2) : (this.businessNatureNames = 1);
		},
		/*
		 * 日期组件选择监听
		 */
		pickerChange(e) {
			// 取消长期勾选
			this.checked = false;
		},
		/*
		 * 有效期长期勾选监听
		 */
		checkedChange(e) {
			if (e) {
				// 选中长期，设置日期默认值
				this.license.Time = '2999-12-31';
			} else {
				// 取消长期勾选，清空日期框
				this.license.Time = '';
			}
		},
		/*
		 * 文件上传按钮显示切换（营业执照）
		 */
		licenseChange(file, fileList) {
			this.count = fileList.length;
		},
		/*
		 * 上传成功监听
		 */
		async handleUploadRequest(file) {
			let url = await oss(this.getAction.bind(this), file, bucketConfig['hys-cualifications'], window.localStorage.getItem('UserId'));
			this.license.ImgList.push(url);
		},
		/*
		 * 图片删除
		 */
		handleRemove(file, fileList) {
			let url = '';
			if (typeof file.response === 'undefined') {
				url = file.url;
			} else {
				url = file.response.Data;
			}
			this.license.ImgList.forEach((value, index, array) => {
				if (typeof file.response === 'undefined') {
					if (value.indexOf('aliyun')) {
						if (value === url) {
							this.license.ImgList.splice(index, 1);
						}
					} else {
						
					}
				} else {
					if (value === url) {
						this.license.ImgList.splice(index, 1);
					}
				}
			});
			this.count = fileList.length;
		},
		/*
		 * 图片预览
		 */
		handlePictureCardPreview(file) {
			this.operationState !== 3 ? (this.dialogImageUrl = file.url) : (this.dialogImageUrl = file);
			this.dialogVisible = true;
		},
		/*
		 * 图片上传限制
		 */
		beforeAvatarUpload(file) {
			const isLt5M = file.size / 1024 / 1024 < 3;
			if (!isLt5M) {
				this.$message.error('上传图片大小不能超过 3MB!');
			}
			return isLt5M;
		}
	}
};
</script>

<style lang="less" scoped>
/deep/.msg {
	color: #ff3939;
	font-size: 10px;
	padding: 0 5px;
}
/deep/.el-upload--picture-card {
	width: 160px !important;
	height: 94px !important;
	line-height: 100px !important;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
	width: 160px !important;
	height: 94px !important;
}
/deep/.flex-palace {
	display: flex;
	margin: 0;
	/deep/li {
		flex: 0 0 160px;
		height: 94px;
		margin: 0 10px 0 0;
		/deep/img {
			border-radius: 4px;
		}
	}
}
/deep/.licenseBox .el-upload--picture-card {
	background-image: url(../../../../assets/myQualifications/icon4.png);
	background-size: cover;
}
.hide {
	height: 95px;
	/deep/.el-upload--picture-card {
		display: none;
		background-color: #fbfdff !important;
	}
}
/deep/.el-upload-list__item {
	transition: none;
}
</style>
